import { PdfViewer } from '@/components/pdfViewer';
import classnames from 'classnames/bind';
import { useCreateObjectURL } from 'packages-hooks';
import { FC, memo, useMemo } from 'react';
import styles from './Preview.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  invoice: File;
};

export const FilePreview: FC<Props> = memo(({ invoice }) => {
  const blob = useMemo(() => {
    return new Blob([invoice], { type: invoice.type });
  }, [invoice]);

  const url = useCreateObjectURL(blob);

  return (
    <div className={cx(styles['preview-container'])}>
      <PdfViewer src={url} />
    </div>
  );
});
FilePreview.displayName = 'FilePreview';
